// src/pages/SpecialSolutions.js 
// (Assuming this file contains your SpecialSolutions component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; 
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import SpecialSolutions_PageContent from './PageComponent/SpecialSolutions_PageContent';

function SpecialSolutions() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Special Solutions for Challenging Architectural Designed Windows</title>
                <meta
                    name="description"
                    content="Marvel Decor LTD. provides solution for sloped and inclined glass surfaces, patio roofs and asymmetrical conservatory glazing"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/special-solutions/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Special Solutions" />
                <meta
                    property="og:description"
                    content="Marvel Decor LTD. provides solution for sloped and inclined glass surfaces, patio roofs and asymmetrical conservatory glazing"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/special-solutions/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <SpecialSolutions_PageContent />
                <Footer />
            </div>
        </>
    );
}

export default SpecialSolutions;